import qoalaStorage from '~/core/Storage';

export default {
  setHcpData(state, value) {
    state.hcpData = value;
    qoalaStorage.setItem('hcpData', JSON.stringify(value));
  },
  setListProduct(state, value) {
    state.listProduct = value;
    qoalaStorage.setItem('hcpProduct', JSON.stringify(state.listProduct));
  },
  setProductDetail(state, value) {
    state.productDetail = value;
    qoalaStorage.setItem('productDetailHcp', JSON.stringify(state.productDetail));
  },
  deleteHcpData(state) {
    state.hcpData = {};
    state.productDetail = {};
    state.listProduct = {};
    qoalaStorage.removeItem('hcpData');
    qoalaStorage.removeItem('hcpProduct');
    qoalaStorage.removeItem('productDetailHcp');
  }
};
